import PropTypes from 'prop-types';

export const HEADER_Y_AXIS_PADDING = 20;

export const PAGE_X_AXIS_PADDING_BY_BREAKPOINT = {
    XXSMALL: 15,
    XSMALL: 15,
    SMALL: 35,
    MEDIUM: 42,
    LARGE: 53,
    XLARGE: 60,
    XXLARGE: 60,
};

export const LOGIN_STATE = {
    LoggedOut: 0,
    SoftLoggedIn: 1,
    LoggedIn: 2,
};

export const USER_TYPE = {
    Patient: 0,
    Provider: 1,
    ZdEmployee: 2,
    BookingAgent: 9,
};

export const NOTIFICATION_TYPE = {
    ZocdocMessage: 'zocdocmessage',
    AppointmentConfirmed: 'appointmentconfirmed',
    AppointmentRescheduled: 'appointmentrescheduled',
    AppointmentCancelled: 'appointmentcancelled',
    AppointmentInfoNeeded: 'appointmentinfoneeded',
    AppointmentCheckIn: 'appointmentcheckin',
    AppointmentFeedback: 'appointmentfeedback',
    AppointmentAsyncBookingFailure: 'appointmentasyncbookingfailure',
};

export const STATE_KEYS = {
    User: 'user',
    LoginState: 'login_state',
    Notifications: 'notifications',
    UnseenNotificationCount: 'unseen_notification_count',
    UpcomingAppointments: 'upcoming_appointments',
    UserType: 'user_type',
};

export const LayoutPropTypes = {
    loginState: PropTypes.oneOf(Object.values(LOGIN_STATE)),
    userType: PropTypes.oneOf(Object.values(USER_TYPE)),
};
